module.exports = __webpack_public_path__ + "img/smoker.1ea00fbc.svg";